import React from 'react'
import moment from 'moment'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { apiFormat, format } from '@cbgms/base/utils/datetime'
import { ChartOptions } from '../ChartOptions/ChartOptions'
import { StatisticsDashboard } from '@cbgms/api/modules/statistics'

interface GenericMonitorChartProps {
  data: StatisticsDashboard[]
  title: string
  dataSelector: (row: StatisticsDashboard) => number
}

const GenericMonitorChart: React.FC<GenericMonitorChartProps> = props => {
  const mappedData = props.data.map(row => {
    return {
      name: moment(row.StartDate, apiFormat.yearMonthDay).format(format.monthLong),
      y: props.dataSelector(row)
    }
  })

  const options = ChartOptions(mappedData, '45%', false)

  if (options.series) {
    options.series[0].name = props.title
  }

  return (
    <div className='chart'>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  )
}

export default GenericMonitorChart
